import { setTokens } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

/**
 * Authorize with SSO
 * @param {string} code - The code returned from the SSO redirect
 * @param {string=} state - The WorkOS state returned from the SSO redirect
 * @returns tokens
 */
const authorizeWithSSO = async (code, state) => {
  const queryParams = new URLSearchParams({ code });
  // Only null/undefined means legacy code-only; an empty callback state should
  // still be sent so Scorpius can reject the mismatch.
  if (state !== undefined && state !== null) {
    queryParams.set('state', state);
  }

  const response = await fetch(
    `${getAPIHost()}/v1/scorpius/sso/authorize?${queryParams.toString()}`,
    {
      method: 'GET',
      credentials: 'include',
    },
  );

  const tokens = await response.json();

  if (!tokens.token) {
    throw new Error('No access token found');
  }

  setTokens(tokens);
  return tokens;
};

export default authorizeWithSSO;
